import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import classnames from "classnames";
import { config } from "_src/servers/v1/users";
import { createNotification } from "_src/utils";
import { useAppSelector } from "_src/store/hooks";
import ReactLoading from "react-loading";

import Icon from "../Icon";
import Button from "../Button";
import Modal from "../Modal";

import "./index.less";


const Index = ({
  visible,
  handleClose,
  className,
}) => {
  const { t } = useTranslation();
  const iframeRef = useRef()
  const { address, networkId, lng } = useAppSelector((store) => store.global);
  const iframeLoad = () => {
    iframeRef.current.contentWindow.postMessage({ from: 'send' }, '*')
  }
  useEffect(() => {
    getConfiguration()
  }, []);

  const [url, setUrl] = useState('');
  const [type, seType] = useState(true);
  const [select, setSelect] = useState(false);
  const getConfiguration = async () => {
    const result = await config({ isNoNeedToken: true, chain_id: networkId, source: "alchemy" });
    if (result && result.code == 1000) {
      const { app_id, callback_url, origin_url, show_table, net_work } = result.data
      setUrl(`${origin_url}?appId=${app_id}&network=${net_work}&language=${lng === "zh-TW" ? "zh-HK" : lng}&showTable=${show_table}&callbackUrl=${callback_url}&address=${address}`)
    } else {
      createNotification(
        result?.message,
        "icon-status-error"
      );
    }
  };
  useEffect(() => {
  }, [localStorage.getItem("i18nextLng")]);//监听国际化切换
  return (
    <div>
      <Modal
        className={classnames("globalPayments", className)}
        visible={visible}
        title={type ? t("globalPayments.tips") : t("globalPayments.buy_crypto_with_card")}
        handleClose={handleClose}
        width={580}
      >
        {
          type ? <>
            <p className="title">{t("globalPayments.unsupported_country")}</p>
            <p className="countries">{t("globalPayments.countries")}</p>
            <p className="payments_explain">{t("globalPayments.payments_explain")}</p>
            <p className="paymentsAcknowledge">
              {select === false ? (
                <span className="radioBox" onClick={() => setSelect(true)}></span>
              ) : (
                <Icon
                  type="icon-select-colourless"
                  onClick={() => setSelect(false)}
                  className="icon-arrow-down"
                />
              )
              }
              {t("globalPayments.acknowledge")}
            </p>
            <Button
              disabled={!select}
              className="continueButton"
              onClick={() => {
                seType(false)
              }}
            >
              {t("globalPayments.continue")}
            </Button>
          </> : <>
            {
              url === '' ? <ReactLoading
                className="wallet-button-loading"
                type="spokes"
                color="#fff"
                height={16}
                width={16}
              /> : <iframe ref={iframeRef} className="iframe" src={url} title="preview" onLoad={iframeLoad}></iframe>
            }
            <img className="globalPaymentsImg" src={require("_src/assets/images/globalPayments/globalPayments.png")} alt="" />
          </>
        }
      </Modal>
    </div>
  );
};

export default Index;
